import { createFileRoute, Link } from "@tanstack/react-router";
import { BUSINESS } from "@/lib/site-data";

export const Route = createFileRoute("/about")({
  head: () => ({
    meta: [
      { title: `About ${BUSINESS.shortName} — Trades-Only SEO Agency` },
      {
        name: "description",
        content: `${BUSINESS.name} has run SEO and Google Ads for trades contractors from ${BUSINESS.address.locality}, ${BUSINESS.address.region} since ${BUSINESS.founded}. Trades-only, cost-per-lead reporting, no long-term contracts.`,
      },
      { property: "og:title", content: `About ${BUSINESS.shortName}` },
      {
        property: "og:description",
        content: `Trades-only SEO and SEM agency in ${BUSINESS.address.locality}, ${BUSINESS.address.region} since ${BUSINESS.founded}.`,
      },
      { property: "og:url", content: "/about" },
    ],
    links: [{ rel: "canonical", href: "https://lehitradessaeo.com/about" }],
  }),
  component: AboutPage,
});

function AboutPage() {
  return (
    <main className="mx-auto max-w-3xl px-6 py-20">
      <p className="text-xs font-medium uppercase tracking-[0.2em] text-muted-foreground">
        About us
      </p>
      <h1 className="mt-4 font-display text-5xl tracking-tight md:text-6xl">
        Trades only. Cost-per-lead first.
      </h1>
      <div className="mt-8 space-y-5 text-lg leading-relaxed text-muted-foreground">
        <p>
          {BUSINESS.name} was founded in {BUSINESS.founded} in {BUSINESS.address.locality}, {BUSINESS.address.region}
          after years of watching trades contractors get burned by generalist agencies
          that didn't understand the unit economics of a service call. We work with
          HVAC, plumbing, electrical, roofing, and remodeling companies — and nothing
          else.
        </p>
        <p>
          One trades client per service per city. That means we never run SEO for two
          competing HVAC companies in Lehi, and we won't pitch the next plumber down
          the street once we sign you. You get the whole moat.
        </p>
        <p>
          Everything we do reports back to cost per booked job — not impressions,
          not vanity rankings. After a 90-day initial commitment, management is
          month-to-month. We earn the renewal every month.
        </p>
      </div>
      <dl className="mt-12 grid gap-4 sm:grid-cols-3">
        <div className="rounded-2xl border border-border bg-card p-5">
          <dt className="text-xs font-medium uppercase tracking-[0.2em] text-muted-foreground">Founded</dt>
          <dd className="mt-2 font-display text-3xl">{BUSINESS.founded}</dd>
        </div>
        <div className="rounded-2xl border border-border bg-card p-5">
          <dt className="text-xs font-medium uppercase tracking-[0.2em] text-muted-foreground">License</dt>
          <dd className="mt-2 text-sm">{BUSINESS.license}</dd>
        </div>
        <div className="rounded-2xl border border-border bg-card p-5">
          <dt className="text-xs font-medium uppercase tracking-[0.2em] text-muted-foreground">Focus</dt>
          <dd className="mt-2 text-sm">Trades only — one client per city per trade</dd>
        </div>
      </dl>
      <div className="mt-12">
        <Link
          to="/contact"
          className="inline-block rounded-full bg-primary px-6 py-3 text-sm font-medium text-primary-foreground hover:bg-primary/90"
        >
          Get in touch →
        </Link>
      </div>
    </main>
  );
}